import * as React from 'react'
import { InfoTooltip } from './InfoTooltip'
import { MatchClasses } from '../hooks'
import { AppAvatar } from '@sales-center/components'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useMatchLocationTitles } from '../../hooks'

type Props = {
  styles: MatchClasses
  label: string
}

export const Header: React.FC<Props> = (props) => {
  const { styles, label } = props

  const { locationsTitle, matchLocationTitle } = useMatchLocationTitles()

  return (
    <>
      <Typography sx={styles.title}>
        {matchLocationTitle}
        <InfoTooltip styles={styles} />
      </Typography>
      <Box sx={styles.header}>
        <Box mr={3.5}>
          <AppAvatar variant="outlined" text="SC" />
          <Typography>{label}</Typography>
        </Box>

        <Box>
          <AppAvatar variant="contained" text="PP" />
          <Typography>{locationsTitle}</Typography>
        </Box>
      </Box>
    </>
  )
}
Header.displayName = 'Header'
